﻿export interface IRatingTierItems {
    id: string;
    name: string;
    description: string;
    ratingFactor: number;
    isActive: boolean;
}

export class RatingTierItems implements IRatingTierItems {
    id: string;
    name: string;
    description: string;
    ratingFactor: number;
    isActive: boolean;
}